// extracted by mini-css-extract-plugin
export default {"tooltip":"wz-z","arrow":"xz-z"};